import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { AnalisesGerenteProjetoService } from '../services/analises-gerente-projeto.service';

@Injectable({
  providedIn: 'root'
})
export class AnalisesGerenteProjetoResolver implements Resolve<boolean> {

  constructor(private service: AnalisesGerenteProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}